import {
  FETCH_SUPPORT_CASE_DETAILS,
  FETCH_SUPPORT_CASE_DETAILS_SUCCESS,
  FETCH_SUPPORT_CASE_DETAILS_FAILURE,
  DELETE_FINANCIAL_FORM_DATA,
  DELETE_FINANCIAL_FORM_DATA_SUCCESS,
  DELETE_FINANCIAL_FORM_DATA_FAILURE,
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA,
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_SUCCESS,
  DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_FAILURE,
  TAKE_SUPPORT_AUTOMATION_BACKUP,
  TAKE_SUPPORT_AUTOMATION_BACKUP_SUCCESS,
  TAKE_SUPPORT_AUTOMATION_BACKUP_FAILURE,
  CLEAR_SUPPORT_WORK_AUTOMATION_STATE,
} from "./actionTypes";

export const fetchSupportCaseDetails = (payload) => ({
  type: FETCH_SUPPORT_CASE_DETAILS,
  payload,
});

export const fetchSupportCaseDetailsSuccess = (data) => ({
  type: FETCH_SUPPORT_CASE_DETAILS_SUCCESS,
  data,
});

export const fetchSupportCaseDetailsFailure = (error) => ({
  type: FETCH_SUPPORT_CASE_DETAILS_FAILURE,
  error,
});

export const deleteFinancialFormData = (caseId) => ({
  type: DELETE_FINANCIAL_FORM_DATA,
  payload: { caseId },
});

export const deleteFinancialFormDataSuccess = (data) => ({
  type: DELETE_FINANCIAL_FORM_DATA_SUCCESS,
  data,
});

export const deleteFinancialFormDataFailure = (error) => ({
  type: DELETE_FINANCIAL_FORM_DATA_FAILURE,
  error,
});

export const deleteExecutiveSummaryFinancialData = (caseId) => ({
  type: DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA,
  payload: { caseId },
});

export const deleteExecutiveSummaryFinancialDataSuccess = (data) => ({
  type: DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_SUCCESS,
  data,
});

export const deleteExecutiveSummaryFinancialDataFailure = (error) => ({
  type: DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA_FAILURE,
  error,
});

export const takeSupportAutomationBackup = (payload) => ({
  type: TAKE_SUPPORT_AUTOMATION_BACKUP,
  payload,
});

export const takeSupportAutomationBackupSuccess = (data) => ({
  type: TAKE_SUPPORT_AUTOMATION_BACKUP_SUCCESS,
  data,
});

export const takeSupportAutomationBackupFailure = (error) => ({
  type: TAKE_SUPPORT_AUTOMATION_BACKUP_FAILURE,
  error,
});

export const clearSupportWorkAutomationState = () => ({
  type: CLEAR_SUPPORT_WORK_AUTOMATION_STATE,
});
